module.exports = __webpack_public_path__ + "img/ZJ5059.f13fcfb9.png";